<template>
    <div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<form ref="site_form" @submit.prevent="updateSite">
					<md-card>
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="card-icon">
								<font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
							</div>
							<h4 class="title">Modification du site</h4>
						</md-card-header>
						<md-card-content>
							<div class="md-layout">
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Nom</label>
										<md-input v-model="site.name" required type="text"></md-input>
										<validation-error :errors="apiValidationErrors.name" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-20">
									<md-checkbox v-model="site.is_client_area_available">Espace Client Actif</md-checkbox>
								</div>
                                <div class="md-layout-item md-size-20">
                                    <md-checkbox v-model="site.is_report_direct">Envoie Rapport Direct</md-checkbox>
                                </div>
								<div class="md-layout-item md-size-10">
									<md-checkbox v-model="site.is_group_active">Groupements</md-checkbox>
								</div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Code EBP</label>
										<md-input v-model="site.code_ebp" required type="text"></md-input>
										<validation-error :errors="apiValidationErrors.code_ebp" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-20">
									<md-checkbox v-model="site.is_baiting_unpermanent" :disabled="site.is_smart">Appatage Non Permanent</md-checkbox>
								</div>
                                <div class="md-layout-item md-size-20">
                                    <md-checkbox v-model="site.is_smart">SMART</md-checkbox>
                                </div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Adresse</label>
										<md-input v-model="site.address.addresses" required type="text"></md-input>
										<validation-error :errors="apiValidationErrors.address_addresses" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-25">
									<div class="md-multiselect">
										<label>Activité</label>
										<multiselect v-model="site.activity"
													 :options="activities"
													 :show-labels="false"
													 label="name"
													 track-by="id"
													 placeholder="Activité">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
								<div class="md-layout-item md-size-25">
									<div class="md-multiselect">
										<label>Secteur</label>
										<multiselect v-model="site.sector"
													 :options="sectors"
													 :show-labels="false"
													 label="name"
													 track-by="id"
													 placeholder="Secteur">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-25">
									<md-field class="md-invalid">
										<label>Code Postal</label>
										<md-input v-model="site.address.zip_code" required type="text"></md-input>
										<validation-error :errors="apiValidationErrors.address_zip_code" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-25">
									<md-field class="md-invalid">
										<label>Ville</label>
										<md-input v-model="site.address.city" required type="text"></md-input>
										<validation-error :errors="apiValidationErrors.address_city" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-50">
									<md-field class="md-invalid">
										<label>Horaires - Informations complémentaires</label>
										<md-textarea v-model="site.schedule_comment" name="schedule_comment" md-autogrow></md-textarea>
										<validation-error :errors="apiValidationErrors.schedule_comment" />
									</md-field>
								</div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-25">
									<md-field class="md-invalid">
										<label>Latitude</label>
										<md-input v-model="site.address.geo_lat" type="text"></md-input>
										<validation-error :errors="apiValidationErrors.address_geo_lat" />
									</md-field>
								</div>
								<div class="md-layout-item md-size-25">
									<md-field class="md-invalid">
										<label>Longitude</label>
										<md-input v-model="site.address.geo_long" type="text"></md-input>
										<validation-error :errors="apiValidationErrors.address_geo_long" />
									</md-field>
								</div>
							</div>
							<div class="md-layout mt-4">
								<div class="md-layout-item md-size-25">
									<div class="md-multiselect">
										<label>Technicien attitré</label>
										<multiselect v-model="site.tech1"
													 :options="technicians"
													 :show-labels="false"
													 label="full_name"
													 track-by="id"
													 placeholder="Technicien">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
								<div class="md-layout-item md-size-25">
									<div class="md-multiselect">
										<label>2<sup>ème</sup> technicien</label>
										<multiselect v-model="site.tech2"
													 :options="technicians"
													 :show-labels="false"
													 label="full_name"
													 track-by="id"
													 placeholder="Technicien">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
								<div class="md-layout-item md-size-25">
									<div class="md-multiselect">
										<label>3<sup>ème</sup> technicien</label>
										<multiselect v-model="site.tech3"
													 :options="technicians"
													 :show-labels="false"
													 label="full_name"
													 track-by="id"
													 placeholder="Technicien">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
							</div>
							<md-divider class="mt-4 mb-4"></md-divider>
							<span class="font-medium">Archivage</span>
							<p class="leading-none">L'archivage n'est disponible que si il n'y a aucun contrat actif sur ce site.</p>
							<div class="md-layout">
								<div class="md-layout-item md-size-15">
									<md-checkbox class="mt-4" :class="{'cursor-not-allowed': site.count_active_contracts > 0}"
												 v-model="site.is_archived"
												 :disabled="site.count_active_contracts > 0">Archivé</md-checkbox>
								</div>
							</div>
							<p class="font-medium italic -mt-3" v-if="site.count_active_contracts > 0">Archivage impossible : {{ site.count_active_contracts }} contrat(s) actif(s)</p>
							<div class="md-layout">
								<div class="md-layout-item md-size-100">
									<div class="block-alert danger mt-2" v-if="site.is_archived">
										<p class="font-medium">Le site est archivé ! Il n'est donc pas disponible dans la barre de recherche.</p>
									</div>
								</div>
							</div>
						</md-card-content>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">Enregistrer</md-button>
							<md-button class="md-warning" @click="goBack">Retour</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
		</div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<form ref="site_schedules_form" @submit.prevent="updateSchedules">
					<md-card class="mt-3">
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="card-icon">
								<md-icon>schedule</md-icon>
							</div>
							<h4 class="title">Modification des horaires d'intervention</h4>
						</md-card-header>
						<md-card-content>
							<div class="md-layout md-gutter">
								<day-row v-for="day in site.schedules" :key="day.number" :day="day" :errors="schedulesErrors"
										 @apply="applyOnSchedules" @disable="disableDay"></day-row>
							</div>
						</md-card-content>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">Enregistrer</md-button>
							<md-button class="md-warning" @click="goBack">Retour</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
		</div>
		<div class="md-layout md-gutter">
			<div class="md-layout-item md-size-100">
				<form ref="site_contacts_form" @submit.prevent="updateContacts">
					<md-card class="mt-3">
						<md-card-header class="md-card-header-icon md-card-header-blue">
							<div class="card-icon">
								<font-awesome-icon class="md-icon" :icon="['fas', 'address-book']" />
							</div>
							<h4 class="title">Modification des contacts</h4>
						</md-card-header>
						<md-card-content>
							<div class="md-layout md-gutter">
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect md-multiselect-multiple">
										<label>Responsable</label>
										<multiselect v-model="selectedContacts.responsible"
													 :options="site.client.contacts"
													 :multiple="true"
													 :close-on-select="false"
													 :show-labels="false"
													 :custom-label="formatContactLabel"
													 track-by="id"
													 placeholder="Responsable">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect md-multiselect-multiple">
										<label>Donneur d'ordre</label>
										<multiselect v-model="selectedContacts.principal"
													 :options="site.client.contacts"
													 :multiple="true"
													 :close-on-select="false"
													 :show-labels="false"
													 :custom-label="formatContactLabel"
													 track-by="id"
													 placeholder="Donneur d'ordre">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
							</div>
							<div class="md-layout md-gutter mt-2">
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect md-multiselect-multiple">
										<label>Contact RDV</label>
										<multiselect v-model="selectedContacts.rdv"
													 :options="site.client.contacts"
													 :multiple="true"
													 :close-on-select="false"
													 :show-labels="false"
													 :custom-label="formatContactLabel"
													 track-by="id"
													 placeholder="Contact RDV">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect md-multiselect-multiple">
										<label>Contact Rapport</label>
										<multiselect v-model="selectedContacts.rapport"
													 :options="site.client.contacts"
													 :multiple="true"
													 :close-on-select="false"
													 :show-labels="false"
													 :custom-label="formatContactLabel"
													 track-by="id"
													 placeholder="Contact Rapport">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
							</div>
							<div class="md-layout md-gutter mt-2">
								<div class="md-layout-item md-size-50">
									<div class="md-multiselect md-multiselect-multiple">
										<label>Autres</label>
										<multiselect v-model="selectedContacts.others"
													 :options="site.client.contacts"
													 :multiple="true"
													 :close-on-select="false"
													 :show-labels="false"
													 :custom-label="formatContactLabel"
													 track-by="id"
													 placeholder="Contact Rapport">
											<template slot="noOptions">La liste est vide</template>
											<template slot="noResult">Aucun élement correspondant</template>
										</multiselect>
									</div>
								</div>
							</div>
						</md-card-content>
						<md-card-actions md-alignment="left">
							<md-button type="submit" class="md-success">Enregistrer</md-button>
							<md-button class="md-warning" @click="goBack">Retour</md-button>
						</md-card-actions>
					</md-card>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
// Components
import DayRow from '@/pages/Sites/Informations/components/DayRow';
import { ValidationError } from '@/components';

// Mixins
import formMixin from '@/mixins/form-mixin';

export default {
    name: 'InformationsEdit',
    components: {
        DayRow, ValidationError
    },
    mixins: [formMixin],
    data() {
        return {
            site: {
                address: {},
                schedules: [],
				technicians: [],
				contacts: [],
				client: {
					contacts: []
				},
				tech1: {},
				tech2: {},
				tech3: {},
            },
			schedulesErrors: [],
			activities: [],
			sectors: [],
			technicians: [],
			selectedContacts: {
				responsible: [],
				principal: [],
				rdv: [],
				rapport: [],
				others: []
			},
        }
    },
    methods: {
        async updateSite() {
        	let site = {
                id: this.site.id,
                name: this.site.name,
                code_ebp: this.site.code_ebp,
                is_archived: this.site.is_archived,
                is_client_area_available: this.site.is_client_area_available,
                is_group_active: this.site.is_group_active,
                is_baiting_unpermanent: this.site.is_baiting_unpermanent,
                is_smart: this.site.is_smart,
                is_report_direct: this.site.is_report_direct,
                schedule_comment: this.site.schedule_comment,
                activity_id: this.site.activity ? this.site.activity.id : null,
				sector_id: this.site.sector ? this.site.sector.id : null,
                address: this.site.address,
                tech1_id: this.technicians.find(tech => tech.id === this.site.tech1.id)?.id ?? null,
				tech2_id: this.technicians.find(tech => tech.id === this.site.tech2.id)?.id ?? null,
				tech3_id: this.technicians.find(tech => tech.id === this.site.tech3.id)?.id ?? null,
			}
            try {
                await this.$store.dispatch('sites/updateSite', site)
                await this.$store.dispatch('alerts/success', 'Site modifié')

                this.site.activity_id = this.site.activity ? this.site.activity.id : null
                this.site.sector_id = this.site.sector ? this.site.sector.id : null
            } catch (e) {
				this.checkErrors(e.response.data.errors)
				this.setApiValidation(e.response.data.errors)
            }
        },
        async updateSchedules() {
			let activeDays = this.site.schedules.map(day => {
				if(day.isActive) {
					return day.schedules.filter(schedule => {
						return (schedule.start !== null && schedule.start !== "") || (schedule.end !== null && schedule.end !== "")
					})
				}
			})
			let days = activeDays.filter(day => {
				return day !== undefined && day.length > 0
			})
			let site = {
            	id: this.site.id,
				days: days
			}
			try {
            	await this.$store.dispatch('sites/updateSchedules', site)
				await this.$store.dispatch('alerts/success', 'Horaires d\'intervention modifiés')
			} catch (e) {
				e.response.data.errors.map(error => {
					let parts = error.source.pointer.split('.')
					let dayNumber = days[parseInt(parts[1])][0].day_number
					error.source.pointer = parts[0] + '.' + dayNumber + '.' + parts[2] + '.' + parts[3]
				})
				this.schedulesErrors = e.response.data.errors
			}
        },
		async updateContacts() {
        	let contacts = []
			for(const [key, value] of Object.entries(this.selectedContacts)) {
				if(value.length > 0) {
					value.map(contact => {
						contacts.push({
							id: contact.id,
							type: this.formatContactType(key)
						})
					})
				}
			}
			try {
				await this.$store.dispatch('sites/updateContacts', {
					id: this.site.id,
					contacts: contacts
				})
				await this.$store.dispatch('alerts/success', 'Contacts modifiés')
			} catch (e) {}
		},
        disableDay(event) {
            const { origin } = event
            let targetDay = this.site.schedules.find(day => day.number === origin.number)
            targetDay.schedules = [{ start: null, end: null }, { start: null, end: null }]
        },
        applyOnSchedules(event) {
            const { target, origin } = event
            if(target === 'all') {
            	let schedules = []
				this.formatWeekdays().map(day => {
					schedules.push({
						isActive: origin.isActive,
						name: day.name,
						number: day.number,
						schedules: [
							{ day_number: day.number, start: origin.schedules[0].start, end: origin.schedules[0].end },
							{ day_number: day.number, start: origin.schedules[1].start, end: origin.schedules[1].end }
						]
					})
				})
                this.site.schedules = schedules
            } else {
				let targetNumber = 0
                if(target === 'previous') {
					targetNumber = origin.number - 1
                } else {
                    // target === 'next'
					targetNumber = origin.number + 1
                }
				this.site.schedules.filter(day => {
					if(day.number === targetNumber) {
						day.isActive = origin.isActive
						day.schedules = [
							{ day_number: day.number, start: origin.schedules[0].start, end: origin.schedules[0].end },
							{ day_number: day.number, start: origin.schedules[1].start, end: origin.schedules[1].end },
						]
					}
				})
            }
        },
        formatSchedules(data) {
            let formattedSchedules = []
            this.formatWeekdays().map(day => {
                let filteredSchedules = data.filter(s => { return s.day_number === day.number })
                let isActive = filteredSchedules.length > 0
                let schedules = filteredSchedules.length === 0 ? [{ day_number: day.number, start: null, end: null }, { day_number: day.number, start: null, end: null }]
                    : (filteredSchedules.length === 1 ? filteredSchedules.concat([{ day_number: day.number, start: null, end: null }]) : filteredSchedules)
                formattedSchedules.push({
                    ...day, isActive, schedules
                })
            })
            return formattedSchedules
        },
        formatWeekdays() {
            let days = []
            this.$moment.weekdays(true).map((day, index) => {
                days.push({
                    number: index,
                    name: day.charAt(0).toUpperCase() + day.slice(1)
                })
            })
            days.pop()
            return days
        },
		formatContactType(type) {
        	let formattedType = ''
			switch (type) {
        		case 'responsible':
        			formattedType = 'Responsable'
					break;
				case 'principal':
					formattedType = 'Donneur d\'ordre'
					break;
				case 'rdv':
					formattedType = 'Contact RDV'
					break;
				case 'rapport':
					formattedType = 'Contact Rapport'
					break;
				case 'others':
					formattedType = 'Autres'
					break;
			}
			return formattedType
		},
		formatContactLabel(contact) {
			let label = contact.full_name
			if(contact.role) label += ' - ' + contact.role

			return label
		},
		checkErrors(errors) {
        	errors.map(error => {
        		if(error.source.pointer.includes('address')) {
					let parts = error.source.pointer.split('.')
					error.source.pointer = parts[0] + '_' + parts[1]
				}
			})
		},
		async getSiteDetails() {
			const { data } = await this.$store.dispatch('sites/getSiteDetails', this.$route.params.idSite)
			let schedules = this.formatSchedules(data.schedules)
			this.site = {
				...data,
				address: data.address ?? {},
				is_archived: !!data.is_archived,
				is_client_area_available: !!data.is_client_area_available,
				is_group_active: !!data.is_group_active,
				is_baiting_unpermanent: !!data.is_baiting_unpermanent,
				is_report_direct: !!data.is_report_direct,
				is_smart: !!data.is_smart,
				schedules: schedules,
				activity_id: data.activity_id ?? 'none',
				sector_id: data.sector_id ?? 'none',
				tech1: data.technicians.find(tech => tech.pivot.order === 1) ?? { id: 'none' },
				tech2: data.technicians.find(tech => tech.pivot.order === 2) ?? { id: 'none' },
				tech3: data.technicians.find(tech => tech.pivot.order === 3) ?? { id: 'none' },
			}
			this.selectedContacts = {
				responsible: data.contacts.filter(contact => { return contact.pivot.type === 'Responsable' }),
				principal: data.contacts.filter(contact => { return contact.pivot.type === 'Donneur d\'ordre' }),
				rdv: data.contacts.filter(contact => { return contact.pivot.type === 'Contact RDV' }),
				rapport: data.contacts.filter(contact => { return contact.pivot.type === 'Contact Rapport' }),
				others: data.contacts.filter(contact => { return contact.pivot.type === 'Autres' }),
			}
		},
		async getActivities() {
			const { data } = await this.$store.dispatch('activities/getActivites')
			this.activities = data
		},
		async getSectors() {
			const { data } = await this.$store.dispatch('sectors/getSectors')
			this.sectors = data
		},
		async getTechnicians() {
			const { data } = await this.$store.dispatch('users/getTechnicians', { isActive: true, order: 'last_name' })
			this.technicians = data
		},
        goBack() {
            this.$router.go(-1)
        }
    },
    mounted() {
        this.getSiteDetails()
		this.getActivities()
		this.getSectors()
		this.getTechnicians()
    },
    watch: {
        'site.is_smart'(newVal) {
            if(newVal) {
                this.site.is_baiting_unpermanent = true
            }
        }
    }
}
</script>

<style scoped>

</style>
